import * as Sentry from "@sentry/capacitor";
import * as SentryVue from "@sentry/vue";
import type { App } from "vue";

export function initSentry(app: App) {
    // if (!import.meta.env.PROD) {
    //     return;
    // }

    Sentry.init(
        {
            dsn: "https://6d7d55ab2fe9914817640afbb585b1b2@o4511645794041856.ingest.us.sentry.io/4511838505336832",
            // Vue specific settings.
            siblingOptions: {
                vueOptions: {
                    app: app,
                    attachErrorHandler: false,
                    attachProps: true,
                },
            },
            dataCollection: {
                // To disable sending user data and HTTP bodies, uncomment the lines below. For more info visit:
                // https://docs.sentry.io/platforms/javascript/guides/capacitor/configuration/options/#dataCollection
                // userInfo: false,
                // httpBodies: [],
            },
            // Set your release version, such as "getsentry@1.0.0"
            release: import.meta.env.PUBLIC_SOURCE_COMMIT,
            // Set your dist version, such as "1"
            // dist: "<dist>",
            sendDefaultPii: true,
            enableLogs: true,
            integrations: [
                Sentry.browserTracingIntegration(),
                // Sentry.replayIntegration({ // 
                //     maskAllText: true,
                //     blockAllMedia: true,
                // }),
                SentryVue.consoleLoggingIntegration({
                    levels: ['debug', 'info', 'warn', 'error', 'log', 'assert', 'trace'],
                }),
            ],
            tracesSampleRate: 1.0,
            // replaysSessionSampleRate: 0.1,
            // replaysOnErrorSampleRate: 1.0,
            environment: import.meta.env.MODE,
        },
        // Forward the init method from @sentry/vue
        SentryVue.init
    );

    // Sentry.init({
    //     app,
    //     dsn: "https://6d7d55ab2fe9914817640afbb585b1b2@o4511645794041856.ingest.us.sentry.io/4511838505336832",
    //     sendDefaultPii: true,
    //     enableLogs: true,
    //     integrations: [
    //         Sentry.browserTracingIntegration(),
    //         // Sentry.replayIntegration({ // 
    //         //     maskAllText: true,
    //         //     blockAllMedia: true,
    //         // }),
    //         Sentry.consoleLoggingIntegration({
    //             levels: ['debug', 'info', 'warn', 'error', 'log', 'assert', 'trace'],
    //         }),
    //     ],
    //     tracesSampleRate: 1.0,
    //     replaysSessionSampleRate: 0.1,
    //     replaysOnErrorSampleRate: 1.0,
    //     environment: import.meta.env.MODE,
    //     release: import.meta.env.PUBLIC_SOURCE_COMMIT,
    // });
}
